export default "__VITE_ASSET__fc255a73__"